exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#has-many-form-wrapper .group[data-v-29dcd035]{position:relative}#has-many-form-wrapper .group .remove-group[data-v-29dcd035]{position:absolute;left:25px;top:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29dcd035","scoped":true,"hasInlineConfig":false}!/~/sass-loader/lib/loader.js!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/elements/HasManyFormWrapper.vue
// module id = 391
// module chunks = 0